import { isRuCluster } from './isRuCluster';

export const getSupportEmail = (): string =>
  isRuCluster() ? 'support@diagnocat.ru' : 'support@diagnocat.com';
